import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { WallboxSelectStyled } from '../WallboxSelectStyled';
import { rem } from 'polished';

export const WallboxSelectDS = styled(WallboxSelectStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            text-transform: uppercase;
        }
    }
`;
